import React from 'react';

const FooterBottom = () => {
    return (
        <div className="w-full py-10">
            <p className="text-center text-gray-500 text-base">
                © 2025. All rights reserved by Goodness
            </p>
        </div>
    );
};

export default FooterBottom;
